import { render, staticRenderFns } from "./OtherRating.vue?vue&type=template&id=34726322&scoped=true"
import script from "./OtherRating.vue?vue&type=script&lang=js"
export * from "./OtherRating.vue?vue&type=script&lang=js"
import style0 from "./OtherRating.vue?vue&type=style&index=0&id=34726322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34726322",
  null
  
)

export default component.exports